import { useLocalStorage } from 'react-use';

import {
  Box,
  Button,
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogRoot,
  Image,
  ListItem,
  OrderedList,
  SimpleGrid,
  Spacer,
  Text,
  VStack,
} from '@oaknorth/component-core-v2';
import { T, Trans, useTranslation } from '@oaknorth/util-intl';

import IMAGES from '../images/Images';

const SHOW_HOME_PAGE_ALERT_KEY = 'show-new-home-page-alert';
export function NewHomeAlertDialog() {
  const [showHomePageAlert, setShowHomePageAlert] = useLocalStorage<boolean>(SHOW_HOME_PAGE_ALERT_KEY, true);
  const { t } = useTranslation();
  return (
    <DialogRoot
      open={showHomePageAlert === undefined ? true : showHomePageAlert}
      onOpenChange={({ open }) => !open && setShowHomePageAlert(false)}
      placement="center"
      size="4xl"
    >
      <DialogBackdrop />
      <DialogContent>
        <DialogBody padding={8}>
          <SimpleGrid columns={2}>
            <VStack alignItems="flex-start" flex={1} justifyContent="space-between">
              <Trans i18nKey="homePage.alert.guideText">
                <Text>We’ve changed how you navigate between our products.</Text>
                <Text>
                  The crowded left-hand menu is gone. Instead, from any ONCI product page, click the ‘ON’ logo at the
                  top-left to return to the landing page. Here you’ll see:
                </Text>
                <OrderedList>
                  <ListItem>Products available to you</ListItem>
                  <ListItem>Other ONCI products you haven’t yet licensed</ListItem>
                  <ListItem>Additional tools and support options</ListItem>
                </OrderedList>
              </Trans>
              <Spacer />
              <Button
                variant="solid"
                onClick={() => setShowHomePageAlert(false)}
              >{T`homePage.alert.getStarted`}</Button>
            </VStack>
            <Box height="100%" flex={1}>
              <Image src={IMAGES.homePageGuide} alt={t`homePage.alert.image`} />
            </Box>
          </SimpleGrid>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
